
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33763',
  depVersions: {
  "documents-public-ui": "static-1.33763",
  "client-types": "static-1.442",
  "documents-lib": "static-1.33768",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1827",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4754",
  "highcharts": "static-8.98",
  "hs-promise-utils": "static-1.5297",
  "hs-test-utils": "static-1.7689",
  "hub-http": "static-1.5872",
  "hubspot-dlb": "static-2.1773",
  "HubStyleTokens": "static-2.11130",
  "I18n": "static-7.1542",
  "jasmine-immutable": "static-1.2723",
  "jasmine-runner": "static-1.6159",
  "lodash": "static-1.3",
  "quartz": "static-1.6589",
  "react": "static-7.176",
  "react-dlb": "static-1.70",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.65",
  "react-rhumb": "static-1.16338",
  "reporting-data": "static-1.66126",
  "reporting-testing-lib": "static-1.8059",
  "reporting-visualizations": "static-1.58202",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4451",
  "webpack-env": "static-1.54",
  "atom": "static-1.4778",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2171",
  "classnames": "static-2.10",
  "crm_schema": "static-3.90919",
  "cssUtils": "static-1.699",
  "customer-data-filters-ui": "static-1.38554",
  "customer-data-objects": "static-1.7319",
  "customer-data-property-utils": "static-1.7777",
  "data-fetching-client": "static-1.9381",
  "enviro": "static-4.387",
  "FireAlarmUi": "static-1.4241",
  "flux-actions": "static-1.298",
  "FormsCommonComponents": "static-1.85028",
  "FormUrlGenerator": "static-2.4437",
  "foundations-components": "static-1.7329",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3825",
  "HubStyle": "static-2.11438",
  "icons": "static-2.614",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6850",
  "metrics-js": "static-1.9296",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.349",
  "property-description-translator": "static-1.3566",
  "property-translator": "static-1.5120",
  "quartz-config": "static-1.367",
  "quartz-core": "static-1.5808",
  "quick-fetch": "static-1.3643",
  "raven": "static-3.5624",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5091",
  "react-virtualized": "static-2.93",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7868",
  "reference-resolvers-lite": "static-1.7797",
  "report-customization-components": "static-1.12246",
  "reporting-enablement": "static-1.21778",
  "reporting-reports": "static-1.65804",
  "reporting-snowflake": "static-1.54744",
  "reporting-ui-components": "static-2.63398",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4311",
  "sales-content-partitioning": "static-1.8640",
  "SalesContentIndexUI": "static-3.8753",
  "sanitize": "static-1.4181",
  "sanitize-text": "static-1.7846",
  "self-service-api": "static-1.9932",
  "SharedI18nStrings": "static-1.179",
  "SharedLegalStrings": "static-1.1458",
  "signup-constants": "static-1.18221",
  "signup-ui-lego-core": "static-1.20231",
  "signup-ui-url-generator": "static-2.7739",
  "styled-components": "static-2.83",
  "StyleGuideUI": "static-3.482",
  "superstore": "static-1.4479",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10702",
  "ui-addon-i18n": "static-1.10834",
  "ui-addon-react-router-dom": "static-1.9253",
  "ui-addon-upgrades": "static-9.17428",
  "ui-asset-management-lib": "static-1.10569",
  "ui-images": "static-2.1063",
  "UIComponents": "static-3.8077",
  "usage-tracker": "static-1.7042",
  "usage-tracker-container": "static-1.7032",
  "usage-tracker-core": "static-1.6892",
  "usage-tracker-public": "static-1.6853",
  "viral-links-lib": "static-1.6727",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven-hubspot": "static-1.5931",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3143",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2866",
  "quartz-webpack": "static-1.2813",
  "ai-components-ui-library": "static-1.8115",
  "amplitude-session-replay-browser": "static-1.54",
  "foundations-assets": "static-1.4537",
  "foundations-theming": "static-1.4111",
  "quartz-auth": "static-1.264",
  "react-transition-group": "static-1.7",
  "usage-tracker-session-replay": "static-1.4728",
  "foundations-theming-base": "static-1.3096",
  "HeadJS": "static-2.691",
  "framer-motion": "static-1.66",
  "hs-test-utils-bend-plugin": "static-1.2800",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "i18n-data": "static-1.215",
  "moment-timezone": "static-5.77",
  "jasmine": "static-4.4037",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7630",
  "graphql": "static-1.76",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3374",
  "persist-promise": "static-1.3392",
  "reporting-client-types": "static-1.2355",
  "hs-story-utils": "static-1.9133",
  "react-flip-move": "static-1.64",
  "hub-http-shared-msw-handlers": "static-1.9231",
  "hubspotter-http": "static-1.4393",
  "sassPrefix": "static-1.150",
  "conversations-skeleton-state": "static-1.6957",
  "crm-message-bus": "static-1.42123",
  "customer-data-filters-ui-msw-helpers": "static-1.20988",
  "customer-data-objects-ui-components": "static-1.12708",
  "customer-data-reference-ui-components": "static-1.12844",
  "customer-data-ui-utilities": "static-1.9532",
  "framework-builder-read-service-client": "static-1.3762",
  "framework-data-schema-quick-fetch": "static-1.6481",
  "framework-data-schema-resolvers": "static-1.6576",
  "inbound-db-properties-service-client": "static-1.3593",
  "multi-account-reference-resolvers": "static-1.674",
  "onboarding-tours": "static-1.16144",
  "reporting-datasets-permissions-lib": "static-1.12739",
  "ui-addon-teams": "static-1.21098",
  "apollo-stack-hubspot": "static-3.80",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67349",
  "customer-data-properties": "static-1.50511",
  "forms-ai-lib": "static-1.3855",
  "forms-utils-lib": "static-1.11994",
  "foundations-components-test-utils": "static-1.4812",
  "react-dnd-compat": "static-1.4330",
  "react-tinymce": "static-1.54377",
  "tinymce-config": "static-2.53503",
  "ui-gdpr-components": "static-1.10052",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3598",
  "floating-ui": "static-1.50",
  "react-aria": "static-1.60",
  "tanstack-table": "static-1.49",
  "trellis-assets": "static-1.989",
  "ui-fonts": "static-1.392",
  "dispatcher": "static-1.129",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.771",
  "mobile-manifest-mixins": "static-1.464",
  "quartz-head": "static-1.254",
  "quartz-i18n": "static-1.264",
  "quartz-test": "static-1.264",
  "batch-promise": "static-1.1235",
  "external-options-client-types": "static-1.3897",
  "react-colorpicker": "static-2.9919",
  "copilot-toolkit": "static-1.10305",
  "data-quality-ui-library": "static-1.12116",
  "html-to-image": "static-1.48",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40453",
  "reporting-insights-lib": "static-1.904",
  "reporting-plugins": "static-1.9866",
  "ui-addon-draggable-compat": "static-2.3960",
  "ui-addon-opt": "static-4.8096",
  "ui-shepherd-react": "static-3.9850",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24474",
  "hubspot-apollo-client": "static-1.4587",
  "sales-templates-service-types-lib": "static-1.3908",
  "ui-business-units-lib": "static-1.8727",
  "merchandise-lib": "static-1.255",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5339",
  "salesImages": "static-1.519",
  "ts-schema": "static-1.3818",
  "upgrade-management-service-types": "static-1.4214",
  "timezone-utils": "static-2.4951",
  "bender-build-tools": "static-1.2823",
  "chatspot-core": "static-1.19994",
  "chirp-fetch": "static-1.1588",
  "bend-plugin-foundations-theming": "static-1.2594",
  "stylex": "static-1.26",
  "hubspotter-http-shared-msw-handlers": "static-1.9229",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3537",
  "crm-pipelines-api-client-types": "static-1.3879",
  "multi-currency-client-types": "static-1.3436",
  "getting-started-shared-tasks": "static-1.17620",
  "growth-data-modal": "static-1.5039",
  "growth-onboarding-confetti": "static-1.2757",
  "growth-onboarding-next-action-utils": "static-1.1201",
  "navigation-components": "static-1.16997",
  "onboarding-tours-client": "static-1.4358",
  "onboarding-tours-utils": "static-1.210",
  "ui-shepherd-tracker": "static-1.7231",
  "ui-universal-auth": "static-1.8570",
  "user-context": "static-1.4800",
  "cms-field-types": "static-1.4514",
  "content-icons-ui": "static-1.2120",
  "integrations-lib": "static-1.15116",
  "calling-global-api": "static-1.63359",
  "calling-internal-common": "static-1.30995",
  "calling-lifecycle-internal": "static-1.64741",
  "calling-lifecycle-messages": "static-1.57035",
  "commerce-products-lib": "static-1.8570",
  "crm-links": "static-1.5959",
  "file-manager-components": "static-1.22630",
  "google-libphonenumber": "static-1.32",
  "hs-entities": "static-1.362",
  "inbounddb-objects-service-types": "static-1.3964",
  "meetings-icalendar-utils-lib": "static-1.340",
  "object-builder-ui-client": "static-1.47678",
  "pipeline-validation-client-types": "static-1.3700",
  "property-value-citations": "static-1.1125",
  "pulse": "static-1.198",
  "smart-property-lib": "static-1.5568",
  "tiered-pricing": "static-1.677",
  "ui-addon-iframeable": "static-1.8725",
  "final-form": "static-1.64",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19303",
  "tinymce-themes": "static-1.55473",
  "data-token-picker": "static-1.15902",
  "hub-http-contrib": "static-1.2753",
  "interframe": "static-3.4499",
  "tinymce-data": "static-1.39588",
  "tinymce-plugins": "static-1.56617",
  "ui-addon-sales-email": "static-1.4920",
  "magpie-lib": "static-1.5282",
  "magpie-types": "static-1.4742",
  "simple-logging-lib": "static-1.2757",
  "content-assistance-lib": "static-1.7315",
  "dashboard-lib": "static-1.80247",
  "ExportDialog": "static-6.10094",
  "hubspot-prosemirror": "static-1.17361",
  "hubspot-prosemirror-plugins": "static-1.17353",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8393",
  "campaign-roi-lib": "static-1.8006",
  "feedback-loader": "static-1.28691",
  "commerce-analytics-service-client": "static-1.3394",
  "onboarding-scopes": "static-1.6150",
  "apollo-link-hub-http": "static-2.4355",
  "hubspot-apollo-cache": "static-1.46",
  "growth-monetization-service-types": "static-1.4230",
  "nav-client-types": "static-1.2039",
  "purchase-motions-api": "static-1.5342",
  "trials-service-types": "static-1.3631",
  "chatspot-client-types": "static-1.10359",
  "idb-keyval": "static-1.38",
  "reactive-lib": "static-1.432",
  "getting-started-shared-tasks-store": "static-1.16738",
  "cohere-reconnect-lib": "static-1.67",
  "gemini-reconnect-lib": "static-1.24",
  "integrations-error-boundary-lib": "static-1.12531",
  "integrations-tracking-lib": "static-1.5290",
  "native-integrations-shared-strings": "static-1.7494",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10080",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31001",
  "shared-worker-versioning": "static-1.10723",
  "calling-usage-tracker": "static-1.6245",
  "calling-orchestration-shared-library": "static-1.34528",
  "customer-data-tracking": "static-1.6568",
  "products-iframe-lib": "static-1.7096",
  "products-ui-components-shared-msw-handlers": "static-1.9613",
  "location-customization-utils-lib": "static-1.8260",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3863",
  "video-components-external": "static-1.10281",
  "video-data-lib": "static-1.33939",
  "directed-graph": "static-1.644",
  "event-emitter": "static-1.632",
  "breeze-intelligence-kit": "static-1.5184",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9314",
  "fsm": "static-1.3438",
  "policy-lib": "static-1.6508",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9377",
  "navigation-messaging": "static-1.6324",
  "FileManagerLib": "static-1.38270",
  "NamespacedHubStyle": "static-2.8813",
  "FileManagerCore": "static-1.38129",
  "codemirror": "static-5.89",
  "layout-dnd-components": "static-1.11874",
  "layout-dnd-utils": "static-1.10849",
  "react-codemirror": "static-1.10311",
  "ui-addon-emoji-picker": "static-1.9596",
  "ui-brand-identity-lib": "static-1.13455",
  "ui-addon-video-player": "static-1.8428",
  "ui-coaching-tips": "static-1.27694",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8273",
  "payment-link-components": "static-1.22674",
  "EmailSignatureEditor": "static-1.23763",
  "eligibility-engine-service-types": "static-1.2912",
  "universal-page-editor-lib": "static-1.2703",
  "calling-orchestration-schema": "static-1.34753",
  "sales-views-client-types": "static-1.3999",
  "crm-record-cards-service-types": "static-1.3367",
  "content-media-composition-data-lib": "static-1.11082",
  "content-media-compositions": "static-2.15089",
  "media-bridge-lib": "static-1.18421",
  "trellis-story-utils": "static-1.4229",
  "storybook-react": "static-1.27",
  "audio-components": "static-1.5479",
  "FileManagerImages": "static-1.35781",
  "video-components": "static-1.12284",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4240",
  "video-embed": "static-1.34773",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67424",
  "layout-data-lib": "static-1.9174",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6292",
  "commerce-tours-lib": "static-1.5572",
  "growth-onboarding-reliability": "static-1.4794",
  "sales-checkout-service-client": "static-1.3406",
  "draft-convert": "static-2.31",
  "draft-extend": "static-2.46",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21143",
  "sales-email-signature-service-client": "static-1.3547",
  "hls.js": "static-1.33",
  "social-insights-client-types": "static-1.21128",
  "outpost": "static-1.3919",
  "advanced-menus-core": "static-1.14664",
  "advanced-menus-lib": "static-1.11655",
  "ui-memberships-settings-lib": "static-1.33180",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14663",
  "simple-menus-lib": "static-1.16180"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33763",
  "client-types": "/client-types/static-1.442",
  "documents-lib": "/documents-lib/static-1.33768",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1827",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4754",
  "highcharts": "/highcharts/static-8.98",
  "hs-promise-utils": "/hs-promise-utils/static-1.5297",
  "hs-test-utils": "/hs-test-utils/static-1.7689",
  "hub-http": "/hub-http/static-1.5872",
  "hubspot-dlb": "/hubspot-dlb/static-2.1773",
  "HubStyleTokens": "/HubStyleTokens/static-2.11130",
  "I18n": "/I18n/static-7.1542",
  "jasmine-immutable": "/jasmine-immutable/static-1.2723",
  "jasmine-runner": "/jasmine-runner/static-1.6159",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6589",
  "react": "/react/static-7.176",
  "react-dlb": "/react-dlb/static-1.70",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.65",
  "react-rhumb": "/react-rhumb/static-1.16338",
  "reporting-data": "/reporting-data/static-1.66126",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8059",
  "reporting-visualizations": "/reporting-visualizations/static-1.58202",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4451",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4778",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2171",
  "classnames": "/classnames/static-2.10",
  "crm_schema": "/crm_schema/static-3.90919",
  "cssUtils": "/cssUtils/static-1.699",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38554",
  "customer-data-objects": "/customer-data-objects/static-1.7319",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7777",
  "data-fetching-client": "/data-fetching-client/static-1.9381",
  "enviro": "/enviro/static-4.387",
  "FireAlarmUi": "/FireAlarmUi/static-1.4241",
  "flux-actions": "/flux-actions/static-1.298",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85028",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4437",
  "foundations-components": "/foundations-components/static-1.7329",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3825",
  "HubStyle": "/HubStyle/static-2.11438",
  "icons": "/icons/static-2.614",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6850",
  "metrics-js": "/metrics-js/static-1.9296",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "property-description-translator": "/property-description-translator/static-1.3566",
  "property-translator": "/property-translator/static-1.5120",
  "quartz-config": "/quartz-config/static-1.367",
  "quartz-core": "/quartz-core/static-1.5808",
  "quick-fetch": "/quick-fetch/static-1.3643",
  "raven": "/raven/static-3.5624",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5091",
  "react-virtualized": "/react-virtualized/static-2.93",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7868",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7797",
  "report-customization-components": "/report-customization-components/static-1.12246",
  "reporting-enablement": "/reporting-enablement/static-1.21778",
  "reporting-reports": "/reporting-reports/static-1.65804",
  "reporting-snowflake": "/reporting-snowflake/static-1.54744",
  "reporting-ui-components": "/reporting-ui-components/static-2.63398",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4311",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8640",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8753",
  "sanitize": "/sanitize/static-1.4181",
  "sanitize-text": "/sanitize-text/static-1.7846",
  "self-service-api": "/self-service-api/static-1.9932",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1458",
  "signup-constants": "/signup-constants/static-1.18221",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20231",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7739",
  "styled-components": "/styled-components/static-2.83",
  "StyleGuideUI": "/StyleGuideUI/static-3.482",
  "superstore": "/superstore/static-1.4479",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10702",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10834",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9253",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17428",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10569",
  "ui-images": "/ui-images/static-2.1063",
  "UIComponents": "/UIComponents/static-3.8077",
  "usage-tracker": "/usage-tracker/static-1.7042",
  "usage-tracker-container": "/usage-tracker-container/static-1.7032",
  "usage-tracker-core": "/usage-tracker-core/static-1.6892",
  "usage-tracker-public": "/usage-tracker-public/static-1.6853",
  "viral-links-lib": "/viral-links-lib/static-1.6727",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3143",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2866",
  "quartz-webpack": "/quartz-webpack/static-1.2813",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8115",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.54",
  "foundations-assets": "/foundations-assets/static-1.4537",
  "foundations-theming": "/foundations-theming/static-1.4111",
  "quartz-auth": "/quartz-auth/static-1.264",
  "react-transition-group": "/react-transition-group/static-1.7",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4728",
  "foundations-theming-base": "/foundations-theming-base/static-1.3096",
  "HeadJS": "/HeadJS/static-2.691",
  "framer-motion": "/framer-motion/static-1.66",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2800",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "i18n-data": "/i18n-data/static-1.215",
  "moment-timezone": "/moment-timezone/static-5.77",
  "jasmine": "/jasmine/static-4.4037",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7630",
  "graphql": "/graphql/static-1.76",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3374",
  "persist-promise": "/persist-promise/static-1.3392",
  "reporting-client-types": "/reporting-client-types/static-1.2355",
  "hs-story-utils": "/hs-story-utils/static-1.9133",
  "react-flip-move": "/react-flip-move/static-1.64",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9231",
  "hubspotter-http": "/hubspotter-http/static-1.4393",
  "sassPrefix": "/sassPrefix/static-1.150",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6957",
  "crm-message-bus": "/crm-message-bus/static-1.42123",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20988",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12708",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12844",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9532",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3762",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6481",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6576",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3593",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.674",
  "onboarding-tours": "/onboarding-tours/static-1.16144",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12739",
  "ui-addon-teams": "/ui-addon-teams/static-1.21098",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.80",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67349",
  "customer-data-properties": "/customer-data-properties/static-1.50511",
  "forms-ai-lib": "/forms-ai-lib/static-1.3855",
  "forms-utils-lib": "/forms-utils-lib/static-1.11994",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4812",
  "react-dnd-compat": "/react-dnd-compat/static-1.4330",
  "react-tinymce": "/react-tinymce/static-1.54377",
  "tinymce-config": "/tinymce-config/static-2.53503",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10052",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3598",
  "floating-ui": "/floating-ui/static-1.50",
  "react-aria": "/react-aria/static-1.60",
  "tanstack-table": "/tanstack-table/static-1.49",
  "trellis-assets": "/trellis-assets/static-1.989",
  "ui-fonts": "/ui-fonts/static-1.392",
  "dispatcher": "/dispatcher/static-1.129",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.771",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.464",
  "quartz-head": "/quartz-head/static-1.254",
  "quartz-i18n": "/quartz-i18n/static-1.264",
  "quartz-test": "/quartz-test/static-1.264",
  "batch-promise": "/batch-promise/static-1.1235",
  "external-options-client-types": "/external-options-client-types/static-1.3897",
  "react-colorpicker": "/react-colorpicker/static-2.9919",
  "copilot-toolkit": "/copilot-toolkit/static-1.10305",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12116",
  "html-to-image": "/html-to-image/static-1.48",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40453",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.904",
  "reporting-plugins": "/reporting-plugins/static-1.9866",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3960",
  "ui-addon-opt": "/ui-addon-opt/static-4.8096",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9850",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24474",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4587",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3908",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8727",
  "merchandise-lib": "/merchandise-lib/static-1.255",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5339",
  "salesImages": "/salesImages/static-1.519",
  "ts-schema": "/ts-schema/static-1.3818",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4214",
  "timezone-utils": "/timezone-utils/static-2.4951",
  "bender-build-tools": "/bender-build-tools/static-1.2823",
  "chatspot-core": "/chatspot-core/static-1.19994",
  "chirp-fetch": "/chirp-fetch/static-1.1588",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2594",
  "stylex": "/stylex/static-1.26",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9229",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3537",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3879",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3436",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17620",
  "growth-data-modal": "/growth-data-modal/static-1.5039",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2757",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1201",
  "navigation-components": "/navigation-components/static-1.16997",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4358",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.210",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7231",
  "ui-universal-auth": "/ui-universal-auth/static-1.8570",
  "user-context": "/user-context/static-1.4800",
  "cms-field-types": "/cms-field-types/static-1.4514",
  "content-icons-ui": "/content-icons-ui/static-1.2120",
  "integrations-lib": "/integrations-lib/static-1.15116",
  "calling-global-api": "/calling-global-api/static-1.63359",
  "calling-internal-common": "/calling-internal-common/static-1.30995",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64741",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57035",
  "commerce-products-lib": "/commerce-products-lib/static-1.8570",
  "crm-links": "/crm-links/static-1.5959",
  "file-manager-components": "/file-manager-components/static-1.22630",
  "google-libphonenumber": "/google-libphonenumber/static-1.32",
  "hs-entities": "/hs-entities/static-1.362",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3964",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.340",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47678",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3700",
  "property-value-citations": "/property-value-citations/static-1.1125",
  "pulse": "/pulse/static-1.198",
  "smart-property-lib": "/smart-property-lib/static-1.5568",
  "tiered-pricing": "/tiered-pricing/static-1.677",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8725",
  "final-form": "/final-form/static-1.64",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19303",
  "tinymce-themes": "/tinymce-themes/static-1.55473",
  "data-token-picker": "/data-token-picker/static-1.15902",
  "hub-http-contrib": "/hub-http-contrib/static-1.2753",
  "interframe": "/interframe/static-3.4499",
  "tinymce-data": "/tinymce-data/static-1.39588",
  "tinymce-plugins": "/tinymce-plugins/static-1.56617",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4920",
  "magpie-lib": "/magpie-lib/static-1.5282",
  "magpie-types": "/magpie-types/static-1.4742",
  "simple-logging-lib": "/simple-logging-lib/static-1.2757",
  "content-assistance-lib": "/content-assistance-lib/static-1.7315",
  "dashboard-lib": "/dashboard-lib/static-1.80247",
  "ExportDialog": "/ExportDialog/static-6.10094",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17361",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17353",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8393",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8006",
  "feedback-loader": "/feedback-loader/static-1.28691",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3394",
  "onboarding-scopes": "/onboarding-scopes/static-1.6150",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4355",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.46",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4230",
  "nav-client-types": "/nav-client-types/static-1.2039",
  "purchase-motions-api": "/purchase-motions-api/static-1.5342",
  "trials-service-types": "/trials-service-types/static-1.3631",
  "chatspot-client-types": "/chatspot-client-types/static-1.10359",
  "idb-keyval": "/idb-keyval/static-1.38",
  "reactive-lib": "/reactive-lib/static-1.432",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16738",
  "cohere-reconnect-lib": "/cohere-reconnect-lib/static-1.67",
  "gemini-reconnect-lib": "/gemini-reconnect-lib/static-1.24",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12531",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5290",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7494",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10080",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31001",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10723",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6245",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34528",
  "customer-data-tracking": "/customer-data-tracking/static-1.6568",
  "products-iframe-lib": "/products-iframe-lib/static-1.7096",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9613",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8260",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3863",
  "video-components-external": "/video-components-external/static-1.10281",
  "video-data-lib": "/video-data-lib/static-1.33939",
  "directed-graph": "/directed-graph/static-1.644",
  "event-emitter": "/event-emitter/static-1.632",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5184",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9314",
  "fsm": "/fsm/static-1.3438",
  "policy-lib": "/policy-lib/static-1.6508",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9377",
  "navigation-messaging": "/navigation-messaging/static-1.6324",
  "FileManagerLib": "/FileManagerLib/static-1.38270",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8813",
  "FileManagerCore": "/FileManagerCore/static-1.38129",
  "codemirror": "/codemirror/static-5.89",
  "layout-dnd-components": "/layout-dnd-components/static-1.11874",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10849",
  "react-codemirror": "/react-codemirror/static-1.10311",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9596",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13455",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8428",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27694",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8273",
  "payment-link-components": "/payment-link-components/static-1.22674",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23763",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2912",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2703",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34753",
  "sales-views-client-types": "/sales-views-client-types/static-1.3999",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3367",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11082",
  "content-media-compositions": "/content-media-compositions/static-2.15089",
  "media-bridge-lib": "/media-bridge-lib/static-1.18421",
  "trellis-story-utils": "/trellis-story-utils/static-1.4229",
  "storybook-react": "/storybook-react/static-1.27",
  "audio-components": "/audio-components/static-1.5479",
  "FileManagerImages": "/FileManagerImages/static-1.35781",
  "video-components": "/video-components/static-1.12284",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4240",
  "video-embed": "/video-embed/static-1.34773",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67424",
  "layout-data-lib": "/layout-data-lib/static-1.9174",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6292",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5572",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4794",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3406",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-2.46",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21143",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3547",
  "hls.js": "/hls.js/static-1.33",
  "social-insights-client-types": "/social-insights-client-types/static-1.21128",
  "outpost": "/outpost/static-1.3919",
  "advanced-menus-core": "/advanced-menus-core/static-1.14664",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11655",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33180",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14663",
  "simple-menus-lib": "/simple-menus-lib/static-1.16180"
}
};
